import { useState, useEffect } from 'react';

interface UseComponentLoaderProps {
  maxRetries?: number;
  retryDelay?: number;
}

export const useComponentLoader = ({ maxRetries = 3, retryDelay = 1000 }: UseComponentLoaderProps = {}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const [error, setError] = useState<string | null>(null);

  const loadComponent = () => {
    try {
      // Simula il caricamento del componente
      setTimeout(() => {
        setIsLoaded(true);
        setError(null);
      }, 100);
    } catch (err) {
      setError('Errore nel caricamento del componente');
      if (retryCount < maxRetries) {
        setTimeout(() => {
          setRetryCount(prev => prev + 1);
          loadComponent();
        }, retryDelay);
      }
    }
  };

  useEffect(() => {
    loadComponent();
  }, []);

  const retry = () => {
    setRetryCount(0);
    setError(null);
    setIsLoaded(false);
    loadComponent();
  };

  return {
    isLoaded,
    error,
    retryCount,
    retry,
    isLoading: !isLoaded && !error
  };
}; 